import { call, put, takeLatest } from 'redux-saga/effects';
import { deleteReportSuccess, deleteReportFailure, DeleteReportRequestAction } from 'actions/reportActions';
import { handleErrorSaga } from 'sagas/app/handleError';
import * as api from 'api';
import { ApiError } from 'api/fetch';


export function* deleteReportRequestWatcher() {
    yield takeLatest('DELETE_REPORT_REQUEST', deleteReportSaga);
}

export function* deleteReportSaga(action: DeleteReportRequestAction) {
    const reportId = action.payload;
    try {
        const success = yield call(api.reports.deleteReport, reportId);
        if (!success) {
            throw new ApiError('341'); // Operation failed
        }
    }
    catch (err) {
        yield call(handleErrorSaga, err, deleteReportFailure, { reportId });
        return;
    }
    yield put(deleteReportSuccess({ reportId }));
}



// WEBPACK FOOTER //
// ./src/sagas/reports/deleteReportSaga.ts